import router from '@/router'
import { store } from '@/store'

const whiteList = ['/login', '/select-server-line']

router.beforeEach(async (to, from, next) => {
    const token = store.getters['token']
    const userId = store.getters['userId']

    const isLogin = (token && userId) !== undefined

    if (isLogin) {
        if (to.path === whiteList[0] || to.path === whiteList[1]) {
            next({ path: '/' })
        } else {
            next()
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next('/select-server-line')
        }
    }
})
